export default __webpack_public_path__ + "static/media/killing.98eb0648.png";